module.exports = __webpack_public_path__ + "static/img/homeEn.ad3050c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeEn.jpg
// module id = 9Ujh
// module chunks = 1